import { isEmptyOrNil, isNotEmpty, returnIsNotEmptyOrTrue, returnStringIfNotEmpty } from 'src/utilities/hasValue';
import { generateUniqueID } from 'src/features/helper';
import {
  authenticatedApplicantContext,
  authenticatedUser,
  authentication,
  clearStorage,
  unAuthenticatedLoan,
  unAuthenticatedUser
} from 'src/utilities/storage';
import { equals, pathOr } from 'ramda';
import { ROLE_BORROWER, ROLE_COBORROWER } from 'src/constants';
import { USER_ONBOARD_COBORROWER } from 'src/services/constants/accounts';
import { decodeLoanData } from 'src/features/LoansHome/Products/init_coloan';
import { getQueryParam } from 'src/utilities/queryParams';
import { LoanRole } from 'src/types/Loan';
import { LoanProductFinder } from 'src/features/NoAuth/LoanProductFinder';



export const resetLeadData = () => {
  unAuthenticatedUser.leadUID.set(generateUniqueID());
}



export const resetSessionData = () => {
  clearStorage([
    unAuthenticatedUser,  
    unAuthenticatedLoan,
    authenticatedUser,
    authenticatedApplicantContext,
    authentication],
    ['advisorUsername', 'campaign', 'workFlowIntent', 'productType', 'user', 'rememberMe']
  )
}

// setQueryParamIntoSessionData is used to update session which is on URL query param's
// only if we have the loanData query params
export const setQueryParamIntoSessionData = (
  loanType: string,
  shouldResetLead: boolean,
  loanProducts: any[]
) => {

  /**
   * upon launch new application from in-branch clear the existing loan session data if exists
   */
  const renewal = getQueryParam(location.search, 'renewal');
  const who = getQueryParam(location.search, 'who');
  if (isNotEmpty(who) && isEmptyOrNil(unAuthenticatedUser.workflowStartedAs.get())) {
    unAuthenticatedUser.workFlowIntent.remove();
    clearStorage([unAuthenticatedLoan])
  }


  // We need to create leadOnly once upon direct url of product workflow
  // to avoid duplicat lead id for same workflow
  // other wise every time production landing (parent of this path) will set leadUID
  shouldResetLead && resetLeadData()
  const finder = new LoanProductFinder(loanType, loanProducts);
  const productType = unAuthenticatedUser.productType.get();
  const campaign = unAuthenticatedUser.campaign.get();

  unAuthenticatedUser.productType.set(isNotEmpty(productType) ? productType : finder.subProductSlug());
  unAuthenticatedUser.aliasName.set(finder.headURLSlug());
  const loanData = getQueryParam(location.search, 'loanData');
  // const email = getQueryParam(location.search, 'email');
  const advisor = getQueryParam(location.search, 'advisor');
  
  isNotEmpty(renewal) && unAuthenticatedUser.renewal.set(renewal);
  isNotEmpty(advisor) && unAuthenticatedUser.advisorUsername.set(advisor);
  isNotEmpty(who) && unAuthenticatedUser.workflowStartedAs.set(who);
  isNotEmpty(campaign) && unAuthenticatedUser.campaign.set(campaign);
  if (isNotEmpty(loanData)) {
    const decodedLoanData = decodeLoanData(loanData);
    const invitationType = pathOr('', ['invitation_type'], decodedLoanData);
    const loanRole: LoanRole = returnIsNotEmptyOrTrue(
      equals(invitationType, USER_ONBOARD_COBORROWER),
      ROLE_COBORROWER,
      ROLE_BORROWER
    );
    unAuthenticatedUser.loanData.set(loanData);
    unAuthenticatedUser.userType.set(loanRole);
    return
  }
  const userType = unAuthenticatedUser.userType.get()
  // Default userType would be always borrower only if we dont have any value on userType session
  isEmptyOrNil(userType) && unAuthenticatedUser.userType.set(ROLE_BORROWER);
}


export const useSessionHook = () => {
  const productAliasName = unAuthenticatedUser.aliasName.get();
  const signupType = unAuthenticatedUser.signupType.get();
  const productType = unAuthenticatedUser.productType.get();
  const userType = unAuthenticatedUser.userType.get();
  const leadID = unAuthenticatedUser.leadUID.get();
  const workFlow = unAuthenticatedUser.workFlowIntent.get();
  const encodedLoanData = unAuthenticatedUser.loanData.get();
  const inviteParams = unAuthenticatedUser.inviteParams.get();
  const loanData = decodeLoanData(encodedLoanData);
  const advisorUsername = unAuthenticatedUser.advisorUsername.get() || pathOr(null, ['advisor_username'], loanData);
  const campaign = unAuthenticatedUser.campaign.get()
  const inviteType = unAuthenticatedUser.workflowStartedAs.get()
  const renewal = unAuthenticatedUser.renewal.get()

  return {
    productAliasName: returnStringIfNotEmpty(productAliasName),
    signupType: returnStringIfNotEmpty(signupType),
    workFlow: returnStringIfNotEmpty(workFlow),
    productType: returnStringIfNotEmpty(productType) || pathOr('', ['product_type'], loanData),
    loanRole: returnStringIfNotEmpty(userType) || ROLE_BORROWER,
    invitationType: pathOr('', ['invitation_type'], loanData),
    leadID: returnStringIfNotEmpty(leadID),
    loanData,
    inviteParams,
    advisorUsername,
    encodedLoanData,
    campaign,
    inviteType,
    renewal
  }
}
